import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZendesk = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	role: "img",
	focusable: "false",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m 6.5425,11.5475 -5.5425,0 5.5425,-6.6915 0,6.6915 z m 6.4575,0 -5.5425,0 c 0,-1.5315 1.2395,-2.7715 2.7715,-2.7715 1.5315,0 2.771,1.241 2.771,2.7715 z m -5.5425,-2.402 0,-6.693 5.5425,0 -5.5425,6.693 z M 6.5425,2.4525 C 6.5425,3.983 5.302,5.2245 3.771,5.2245 2.241,5.2245 1,3.984 1,2.4535 l 5.5425,0 0,-10e-4 z"
	})
});
export default SvgZendesk;
